<template>
    <div class="about" ref="scroll" v-wechat-title="$route.meta.title">

        <van-tabs v-model="active" swipeable sticky animated class="tab" color="#1E90FF" title-active-color="#1E90FF"
            title-inactive-color="#323232" @change="changeTab(active)" :ellipsis="false">

            <van-tab :title="'帮助中心'" class="tab_tit">
                <div class="tab_con" v-show="active == 0">
                    <div class="description">

                        <van-search placeholder="请输入搜索关键词" v-model="keys" shape="round" show-action
                            @search="SearchHelp()">

                            <div slot="action" @click="SearchHelp">搜索</div>
                        </van-search>

                        <div class="help_wrap">
                            <div class="card_tit">最近更新</div>
                            <div class="card_hot">
                                <ul>
                                    <li v-for="(Recently, index) in RecentlyList" :key="index"
                                        @click="goDetail(Recently.id)">
                                        <i class="disc"></i>
                                        <p>{{ Recently.title }}</p>
                                    </li>
                                    <li @click="goVideo">
                                        <i class="disc" ></i>
                                        <p>诺云科技无人直播教程</p>
                                    </li>
                                </ul>
                            </div>

                            <div class="card_tit">
                                <span>常见问题</span>
                                <router-link class="more" to="/helps">更多</router-link>
                            </div>
                            <div class="common_problem">
                                <div class="problem_item" v-for="(Common, Cindex) in CommonList" :key="Cindex">
                                    <div class="item_cagy">
                                        <div class="cagy_left" @click="goCategory(Common.Category.id)">
                                            <img :src="Common.Category.coverpath" alt="" srcset="">
                                            <span>{{ Common.Category.categoryname }}</span>
                                        </div>
                                        <div class="cagy_right">
                                            <van-icon name="arrow" />
                                        </div>

                                    </div>
                                    <div class="problem">
                                        <div class="item" @click="goDetail(Childrens.id)"
                                            :class="{ 'one': Common.Childrens.length == 1 }"
                                            v-for="(Childrens, index) in Common.Childrens" :key="index">
                                            {{ Childrens.title }}</div>

                                    </div>

                                </div>

                            </div>

                            <div class="card_tit">反馈建议</div>
                            <div class="card_feedback">
                                <van-field v-model="feedbackText" type="textarea" placeholder="对系统有什么吐槽建议，快点告诉我们吧~~~"
                                    rows="1" autosize :border="false" />
                                <div class="button_wrap">
                                    <button :class="{ 'active': feedbackText != '' }" @click="submit">提交</button>
                                </div>

                            </div>


                        </div>



                    </div>

                </div>
            </van-tab>

            <van-tab :title="'功能更新'" class="tab_tit">
                <div class="tab_con" v-show="active == 1">
                    <div class="background description">
                        <div class="body" v-html="upgradeLogHtml"></div>
                    </div>
                </div>
            </van-tab>
        </van-tabs>
        <wxsdk :isHidden="true" :config="wxconfig"></wxsdk>
    </div>
</template>
<script>
// @ is an alias to /src
import { mapState, mapMutations } from 'vuex'; //先要引入
import videoimg from '@/assets/img/video.png'
import $ from 'jquery'
import { Toast } from 'vant';

import { isAndroid } from '@/util/util'
import mixins from '@/util/mixins'

import { GetUpgradeLog } from '@/api/about'

var icon_search = require("@/assets/img/icon/search.png");
import '@/assets/css/quill.core.css'

export default {
    name: 'about',
    mixins: [mixins],
    data() {
        return {
            active: 0,
            wxconfig: {
                title: '业之峰环保装饰', // 分享标题
                link: window.location.href.split('#')[0], // 分享链接
                desc: '诺云出品，营销神器', // 分享描述
                imgUrl: 'https://picfw.yzf.com.cn/shadow/20200215084744', // 分享图标
            },
            isAndroid: isAndroid(),
            keys: '',
            icon_search: icon_search,
            feedbackText: '',
            RecentlyList: [],//最近更新列表
            CommonList: [],//常见问题列表
            upgradeLogHtml: ''

        }
    },
    components: {
        wxsdk: () => import('@/components/Wxsdk'),
    },
    watch: {},
    computed: {
        ...mapState({
            branchid: "branchid",
        }),

    },
    created() {
        this.DataInit()

        this.wxconfig = {
            title: this.$route.meta.title, // 分享标题
            link: window.location.href, // 分享链接
            desc: '业之峰环保装饰', // 分享描述
            imgUrl: 'https://picfw.yzf.com.cn/shadow/20190704093030', // 分享图标
        }
        // console.log(this.wxconfig)
    },
    mounted() {

        //新功能未读状态，组件不能直接添加class，小红点
        // this.$nextTick(()=>{
        //     if (this.courseNewFun=='') {
        //         // console.log($('#app .about .tab .van-tab').eq(0))
        //         $('#app .about .tab .van-tab').eq(0).addClass('new_fun')
        //     }

        // })


    },
    methods: {
        ...mapMutations(['loadingShow']),
        async DataInit() {
            this.loadingShow('show')
            await this.getCommonList() //拉取常见问题列表
            await this.getRecentlyList() //拉取最近更新列表
            await this.GetUpgradeLog()  // 拉取更新日志
            this.loadingShow('hide')
        },
        // 拉取更新日志
        async GetUpgradeLog() {
            await GetUpgradeLog().then(res => {

                if (res.Success) {
                    this.upgradeLogHtml = res.Object
                }
            })
        },
        SearchHelp() {
            this.$router.push({
                name: "HelpCenter",
                query: {
                    search: this.keys,
                }
            });
        },
        goVideo(){
            console.log(123)
            this.$router.push({
                name: "nulinkVideo",
               
            });
        },
        //去往帮助分类
        goCategory(id) {
            // console.log(id)
            // return
            this.$router.push({
                name: "HelpCenter",
                query: {
                    category: id
                }
            });
        },
        //去往帮助详情
        goDetail(id) {
            // console.log(id)
            this.$router.push({
                name: "HelpDetail",
                query: {
                    id: id,
                }
            });
        },

        //拉取常见问题列表
        getCommonList() {
            return new Promise((resolve, reject) => {
                this.$get('/api/HelpCenter/Common').then((res) => {
                    if (res.Success) {
                        // console.log(res.Object)
                        this.CommonList = res.Object
                    } else {
                        Toast.fail({

                            message: res.Message
                        });
                    }
                    resolve()
                }).catch((err) => {
                    reject()
                })
            })
        },
        //拉取最近更新列表
        getRecentlyList() {
            var data = {
                Count: 3	//是	int	显示的条数
            };
            return new Promise((resolve, reject) => {
                this.$get('/api/HelpCenter/Recently', data).then((res) => {
                    if (res.Success) {
                        // console.log(res.Object)
                        this.RecentlyList = res.Object

                    } else {
                        Toast.fail({

                            message: res.Message
                        });
                    }
                    resolve()
                }).catch((err) => {
                    reject()
                })
            })
        },
        changeTab(active) {
            //小红点
            // if (active==1) {
            //     this.setCourseNewFun('1')
            //     this.$nextTick(()=>{
            //         $('#app .about .tab .van-tab').eq(1).removeClass('new_fun')
            //     })
            // }

        },
        //提交反馈建议
        submit() {
            var data = {
                objectid: this.branchid || '',
                customfieldsvalue: this.feedbackText
            };
            // console.log(data)
            this.$post('/api/Temporary/Post', data).then((res) => {
                if (res.Success) {
                    Toast.success({

                        message: '提交成功'
                    });
                    this.feedbackText = ''
                } else {
                    Toast.fail({

                        message: res.Message
                    });
                }
            }).catch((err) => {

            })
        }

    },

}
</script>
<style lang="scss" scoped>
.about {

    .tab {
        padding-bottom: 90px;

        .van-tab__pane {
            background: #f0f0f0;
        }

        .tab_con {
            background: #f0f0f0;
            min-height: calc(100vh - 90px - 96px);
            overflow: hidden;

            .teach_bg {
                width: 100vw;
                height: auto;
                padding-bottom: 250px;
                background: #ffffff;
            }

            .description {
                margin-bottom: 100px;
                background: #ffffff;


                .help_wrap {
                    padding: 0 25px;
                    background: #f0f0f0;

                    .card_tit {
                        font-size: 30px;
                        color: #333333;
                        font-weight: 600;
                        padding: 30px 0;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;

                        .more {
                            font-size: 24px;
                            font-weight: normal;
                            color: #666666;
                        }
                    }

                    .card_hot {
                        background: #ffffff;
                        border-radius: 20px;
                        padding: 0 25px;

                        ul {
                            li {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                font-size: 26px;
                                color: #333333;
                                padding-top: 20px;
                                height: 40px;

                                p {
                                    flex: 1;
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    height: 40px;
                                    line-height: 40px;
                                }

                                &:last-child {
                                    padding-bottom: 20px;
                                }

                                .disc {
                                    width: 20px;
                                    height: 20px;
                                    border-radius: 50%;
                                    background: #1E90FF;
                                    display: inline-block;
                                    transform: scale(.5);
                                    transform-origin: 0% center;
                                    vertical-align: middle;
                                    margin-right: 10px;
                                }
                            }
                        }
                    }

                    .common_problem {
                        padding: 0 20px;
                        background: #ffffff;
                        border-radius: 20px;

                        .problem_item {

                            display: flex;
                            flex-direction: row;
                            padding: 20px 0;
                            border-bottom: 1px solid #3333;

                            &:last-child {
                                border-bottom: 0;
                            }

                            .item_cagy {
                                display: flex;
                                flex-direction: row;
                                width: 200px;

                                .cagy_left {
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: center;
                                    align-items: center;
                                    width: 130px;

                                    img {
                                        width: 40px;
                                        height: 40px;
                                        margin: 10px 0;
                                    }

                                    span {
                                        font-size: 20px;
                                    }
                                }

                                .cagy_right {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                }

                            }

                            .problem {
                                flex: 1;
                                display: flex;
                                flex-direction: column;
                                justify-content: space-between;
                                font-size: 25px;
                                color: #333333;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;

                                .item {
                                    width: 100%;
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    height: 30px;
                                    line-height: 30px;

                                    // display: flex;
                                    // flex-direction: row;
                                    // align-items: center;
                                    &.one {
                                        height: 100%;
                                        line-height: 100%;
                                        display: flex;
                                        align-items: center;
                                    }

                                }
                            }

                        }


                    }

                    .card_feedback {
                        background: #ffffff;
                        border-radius: 20px;
                        padding: 25px;

                        textarea {
                            line-height: 1.5;
                            font-size: 26px;
                        }

                        .button_wrap {
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-end;

                            button {
                                background: #1E90FF;
                                color: #ffffff;
                                border-radius: 56px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                font-size: 27px;
                                height: 56px;
                                width: 159px;
                                outline: none;
                                border: 0;
                                transition: all .3s;

                                &.active {
                                    background: #1E90FF;
                                }
                            }
                        }
                    }

                }

                .body {
                    padding: 20px;
                    font-size: 26px;
                    line-height: 60px;
                }

            }


            .background {
                background: #fff;
                min-height: calc(100vh - 90px - 96px);
                text-align: left;
                overflow: hidden;

                h1 {
                    margin-top: 30px;
                    font-size: 40px;
                    color: #333333;
                    margin-bottom: 20px;
                    text-align: center;
                }

                p {
                    color: #999999;
                    font-size: 26px;
                    text-align: center;
                    margin-bottom: 30px;
                    margin-top: 50px;
                }
            }
        }

    }
}
</style>